module.exports = __webpack_public_path__ + "img/strategies.f5087a56.svg";